import React, { createContext, useContext, useState, useCallback } from 'react';

const CookieConsentContext = createContext();

const CONSENT_KEY = 'cookie_consent';

const getStoredConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const CookieConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(() => getStoredConsent());

  const acceptCookies = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setConsent('accepted');
  }, []);

  const declineCookies = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setConsent('declined');
  }, []);

  return (
    <CookieConsentContext.Provider value={{ consent, acceptCookies, declineCookies }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => useContext(CookieConsentContext);
